import { createSelector } from "reselect";

const selectReqs = (state) => state.reqs;

export const selectReqsActiveTab = createSelector(
  selectReqs,
  (reqs) => reqs.activeTab
);

export const selectMyReqs = createSelector(selectReqs, (reqs) => reqs.myReqs);
export const selectMyReqsIsLoading = createSelector(
  selectReqs,
  (reqs) => reqs.myReqs_isLoading
);
export const selectMyReqsPage = createSelector(
  selectReqs,
  (reqs) => reqs.myReqsPage
);

export const selectAllReqs = createSelector(selectReqs, (reqs) => reqs.allReqs);
export const selectAllReqsIsLoading = createSelector(
  selectReqs,
  (reqs) => reqs.allReqs_isLoading
);
export const selectAllReqsPage = createSelector(
  selectReqs,
  (reqs) => reqs.allReqsPage
);
